import { stateful, useState } from '@adornis/functional-lit/stateful.js';
import { html } from 'lit';

export const Connected = stateful(() => {
  const [status] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return {
      provider: params.get('provider') ?? 'unknown',
      status: params.get('status') ?? 'unknown',
    };
  });

  const isSuccess = status().status === 'success';
  const providerLabel = status().provider === 'linkedin' ? 'LinkedIn' : 'Email';

  return html`
    <div class="ndi-gradient flex min-h-screen items-center justify-center">
      <div class="card bg-base-100 ndi-auth-card w-full max-w-sm shadow-xl">
        <div class="card-body items-center text-center">
          ${isSuccess
            ? html`
                <span class="icon-[material-symbols--check-circle] text-6xl text-success"></span>
                <h2 class="card-title text-xl mt-2">${providerLabel} Connected!</h2>
                <p class="text-sm text-base-content/70">Your account has been successfully linked. You can close this window.</p>
              `
            : html`
                <span class="icon-[material-symbols--error] text-6xl text-error"></span>
                <h2 class="card-title text-xl mt-2">Connection Failed</h2>
                <p class="text-sm text-base-content/70">Could not connect your ${providerLabel} account. Please try again from Settings.</p>
              `}
          <button class="btn btn-sm mt-4" @click=${() => window.close()}>Close Window</button>
        </div>
      </div>
    </div>
  `;
});
